// /src/api/LeadExecutionEngine.jsx
// VERSÃO 15.0 ARES - CONSOLIDADO E LIMPO

import apiClient from './apiClient';
import { toast } from 'react-toastify';

export const LeadExecutionEngine = {
    
    /**
     * 📥 RADAR POR STATUS
     */
    async listarPorStatus(status) {
        try {
            const { data } = await apiClient.get(`/api/leads-intel/status/${status}`);
            return Array.isArray(data) ? data : [];
        } catch (error) {
            console.error(`❌ Erro no radar ${status}:`, error);
            return [];
        }
    },
    
    /**
     * 🟢 RADAR DE TODOS ATIVOS (KANBAN)
     */
    async listarAtivos() {
        try {
            const { data } = await apiClient.get(`/api/leads-intel/active`);
            return Array.isArray(data) ? data : [];
        } catch (error) {
            console.error(`❌ Erro no radar de leads ativos:`, error);
            return [];
        }
    },

    /**
     * 🔄 ATUALIZAÇÃO DE STATUS (DRAG & DROP)
     */
    async atualizarStatus(leadId, novoStatus, operador, comentario) {
        try {
            const { data } = await apiClient.put(`/api/leads-intel/${leadId}/status`, { novoStatus, operador, comentario });
            return data.success;
        } catch (error) {
            console.error(`❌ [LeadExecutionEngine] Erro crítico ao atualizar status do lead ${leadId}:`, error.response?.data || error.message);
            // Propagar o erro para o frontend lidar visualmente caso seja necessário
            if (error.response?.data?.detail) {
                console.error(`Detalhes da falha no servidor: ${error.response.data.detail}`);
            }
            return false;
        }
    },

    /**
     * ⚙️ CONFIGURAÇÃO DE RODÍZIO
     */
    async obterStatusRodizio() {
        try {
            const { data } = await apiClient.get('/api/leads/config/distribution');
            return data.autoDistribute;
        } catch (error) {
            console.error("❌ Erro ao acessar config de rodízio:", error);
            return false;
        }
    },

    async alternarRodizio(novoStatus) {
        try {
            const { data } = await apiClient.patch('/api/leads/config/toggle', { status: novoStatus });
            toast.info(data.autoDistribute ? "🚀 RODÍZIO AUTOMÁTICO ATIVADO" : "🛑 MODO MANUAL ATIVADO");
            return data.autoDistribute;
        } catch (error) {
            toast.error("FALHA AO ALTERAR MODO");
            return false;
        }
    },

    /**
     * 🎖️ ATRIBUIÇÃO E ALISTAMENTO
     */
    async atribuirMissao(leadId, brokerId) {
        try {
            const { data } = await apiClient.patch(`/api/leads/assign/${leadId}`, { brokerId });
            toast.success("AGENTE DESIGNADO COM SUCESSO!");
            return data.success;
        } catch (error) {
            toast.error("FALHA NA ATRIBUIÇÃO.");
            return false;
        }
    },

    async cadastrarLeadManual(leadData) {
        try {
            const { data } = await apiClient.post('/api/leads/manual', leadData);
            toast.success("🎯 RECRUTA ALISTADO MANUALMENTE!");
            return data.success;
        } catch (error) {
            toast.error("ERRO NO ALISTAMENTO MANUAL.");
            return false;
        }
    },

    /**
     * 🆙 EVOLUÇÃO UNIVERSAL (Versionamento v1, v2...)
     */
    async evoluirDossier(leadId, fullData) {
        try {
            const { data } = await apiClient.patch(`/api/leads-intel/refine/${leadId}`, fullData);
            // newVersion vem do backend para feedback imediato
            toast.success(`🛡️ DOSSIER ATUALIZADO E ARQUIVADO!`);
            return data.success;
        } catch (error) {
            toast.error("ERRO NA EVOLUÇÃO DO DOSSIER.");
            return false;
        }
    },

    /**
     * 💀 PROTOCOLO LIMBO (MASTER ONLY)
     */
    async incinerarLead(leadId) {
        try {
            const { data } = await apiClient.patch(`/api/leads/limbo/${leadId}`);
            toast.warn("🔥 ALVO TRANSFERIDO PARA O LIMBO.");
            return data.success;
        } catch (error) {
            toast.error("ACESSO NEGADO: RESTRITO AO MASTER.");
            return false;
        }
    },
/**
     * 👥 RECRUTAMENTO: LISTAR AGENTES DISPONÍVEIS
     * Retorna a lista de corretores para o Master delegar missões.
     */
    async listarAgentes() {
        try {
            const { data } = await apiClient.get('/api/users/brokers'); // Rota que retorna apenas corretores
            return Array.isArray(data) ? data : [];
        } catch (error) {
            console.error("❌ Erro ao listar agentes:", error);
            return [];
        }
    },

    /**
     * 🥂 CONVERSÃO ELITE
     */
    async promoverACliente(leadId) {
        try {
            await apiClient.patch(`/api/leads/convert/${leadId}`);
            toast.success("🚀 MISSÃO CUMPRIDA: ALVO CONVERTIDO EM CLIENTE!");
            return true;
        } catch (error) {
            toast.error("FALHA NA PROMOÇÃO DO LEAD.");
            return false;
        }
    }
};